export const PROJECT_STATUS_IMPLANTATION = { name: 'Implantação', value: 'implantation' };
export const PROJECT_STATUS_CLOSED = { name: 'Fechado', value: 'closed' };
export const PROJECT_STATUS_EXECUTION = { name: 'Execução', value: 'execution' };

export const PROJECT_STATUS_CONSTRAINTS = [PROJECT_STATUS_IMPLANTATION, PROJECT_STATUS_CLOSED, PROJECT_STATUS_EXECUTION];
export const STATUS_PROJECT_VALUES = PROJECT_STATUS_CONSTRAINTS.map((c) => c.value);

export const defaultReponsibleContract = (projectStatus?: string | null) => PROJECT_STATUS_CONSTRAINTS.map(i => ({ ...i, selected: projectStatus === i.value }))